import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=2999f63f&"
import script from "./TabContent.vue?vue&type=script&lang=js&"
export * from "./TabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem})
